import { Form, Button, Icon, notification, Card, Upload, Modal, Divider } from "antd";
import React from "react";
import Request, { LAPI_URL, MEDIA_URL } from "../../../request";
import { FormUtils as GetAllFormFields } from "sz-react-utils";
import currencies from '../../../currencies.json';
import timezones from "../../../timezone.json";

const activeUser = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
let isModal = false;
@Form.create()
class BasicCompanyDetails extends React.Component {
    state = {
        loading: false,
        cardLoading: false,
        files: [],
        previewVisible: false,
        previewImage: '',
        countries: [],
        dateFormates: [
            'DD/MM/YYYY', 'MM/dd/yyyy', 'dd.MM.yyyy', 'DD.MM.YYYY',
            'DD-MM-YYYY', 'MM-dd-YYYY', 'YYYY.MM.DD', 'DD-MMM-YYYY', 'YYYY-MM-DD'
        ],
        bankArr: [],
    }

    // ✅ LOAD DATA
    loadInitialData = async () => {
        this.setState({ cardLoading: true });

        let res = await Request.getBusinessDetails(activeUser.businessId);
        let bankResponse = await Request.getCompanyDetails();
        let bankArr = bankResponse.data.reduce((temp, vv) => {
            temp.push({ _id: vv._id, display: vv.companyName });
            return temp;
        }, []);

        this.setState({ cardLoading: false, bankArr });

        if (res) {
            if (res.companyLogo && res.companyLogo.length > 0) {
                let file = res.companyLogo[0];

                this.setState({
                    files: [{
                        uid: file.uid || '-1',
                        name: file.name || 'logo.png',
                        status: 'done',
                        url: MEDIA_URL + file.url,
                        value: file.path
                    }]
                });

                this.props.form.setFieldsValue({
                    companyLogo: file.path
                });
            }

            this.props.form.setFieldsValue(res);
        }
    };

    loadCountries = async () => {
        let response = await Request.getCountriesWithoutAuth({
            results: 1000,
            count: 1000,
            businessId: activeUser.businessId,
        })

        let countries = response && response.data.reduce((temp, vv) => {
            temp.push({ _id: vv._id, display: vv.countryName });
            return temp;
        }, []);

        this.setState({ countries })
    }

    componentDidMount() {
        isModal = this.props.isModal;
        this.loadInitialData();
        this.loadCountries();
    }

    // ✅ IMAGE VALIDATION (1020x1020)
    beforeUpload = (file) => {
        return new Promise((resolve, reject) => {
            const isImage = file.type.startsWith('image/');
            if (!isImage) {
                notification.error({ message: 'Only image files allowed' });
                return reject(false);
            }

            const img = new Image();
            img.onload = () => {
                if (img.width !== 130 || img.height !== 80) {
                    notification.error({
                        message: 'Image must be exactly 130 x 80 px'
                    });
                    reject(false);
                } else {
                    resolve(file);
                }
            };
            img.src = URL.createObjectURL(file);
        });
    };

    handlePreview = (file) => {
        this.setState({
            previewImage: file.url,
            previewVisible: true
        });
    };

    onPrev = () => {
        this.props.onPrev();
    }

    handleCancel = () => this.setState({ previewVisible: false });

    handleChange = ({ fileList }) => {

        let newFileList = fileList.slice(-1);

        newFileList = newFileList.map(file => {
            if (file.response && file.response.path) {
                file.url = MEDIA_URL + file.response.path;
                file.value = file.response.path;
            }
            return file;
        });

        this.setState({ files: newFileList });

        // let path = newFileList.length > 0
        //     ? (newFileList[0].value || '')
        //     : '';

        // // this.props.form.setFieldsValue({ companyLogo: path });
    };

    // ✅ SUBMIT
    handleFormSubmit = (e) => {
        e.preventDefault();
        let { form, onNext, isModal } = this.props;

        form.validateFieldsAndScroll(async (err, values) => {
            if (!err) {

                values.businessId = activeUser.businessId;

                // ✅ Phone validation
                if (
                    !values.companyPhone ||
                    values.companyPhone.toString().length !== 10 ||
                    !values.directorPhone ||
                    values.directorPhone.toString().length !== 10
                ) {
                    notification.error({
                        message: 'Phone numbers must be exactly 10 digits'
                    });
                    return;
                }


                if (this.state.files.length > 0) {
                    let files = this.state.files;
                    let file = files[0];

                    if (!file.response) {
                        file.url = file.value;
                        file.path = file.value;
                        delete file.value;
                        delete file.status;
                        files[0] = file;
                    }
                    values.companyLogo = files;
                }

                if (this.state.files.length === 0 && !isModal) {
                    notification.error({
                        message: 'Business logo is required'
                    });
                    return;
                }

                this.setState({ loading: true });

                let response = await Request.addUpdateCompanySetting(values);

                this.setState({ loading: false });

                if (response && response.success) {
                    notification.success({ message: response.message });
                    if (isModal) {
                        this.props.onNext();
                    }

                } else {
                    notification.error({
                        message: response.message || "Failed to update"
                    });
                }
            }
        })
    }

    render() {
        const { form: { getFieldDecorator, setFieldsValue }, phoneCodes, isModal } = this.props;
        const { loading, cardLoading, files, previewVisible, previewImage, countries, bankArr } = this.state;

        const inputSchema = {
            fields: [
                { label: 'Business Name', key: 'companyName', required: true },
                {
                    label: 'Business Email',
                    key: 'companyEmail',
                    type: 'email',
                    required: true,
                    onBlur: (e) => {
                        const email = e.target.value;

                        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

                        if (!emailRegex.test(email)) {
                            notification.error({
                                message: 'Please Enter Valid Business Email Address'
                            })
                            // show error (toast / set state / message)
                        } else {
                            // console.log('Valid email');
                        }
                    }
                },
                { label: 'Business Phone Code', key: 'companyCountryCode', type: 'select', options: phoneCodes, showSearch: true, required: true, onChange: v => { setFieldsValue({ companyCountryCode: v }) } },
                {
                    label: 'Business Phone',
                    key: 'companyPhone',
                    required: true,
                    maxLength: 10,
                    onBlur: (e) => {
                        const value = e.target.value;

                        const phoneRegex = /^[0-9]{10}$/;

                        if (!phoneRegex.test(value)) {
                            notification.error({
                                message: 'Invalid phone number (must be 10 digits)'
                            });
                        } else {

                        }
                    }
                },
                { label: 'Business Address', key: 'companyAddress', type: 'textarea', required: true },
                { label: 'GSTIN No', key: 'companyGst' },
                { label: 'Business PAN', key: 'companyPan' },
                {
                    label: 'Business Default Bank Details',
                    key: 'defaultBankDetail',
                    type: 'select',
                    options: bankArr,
                    hidden: isModal,
                    required: !isModal,
                    onChange: v => {
                        setFieldsValue({ defaultBankDetail: v });
                    }
                },
                { label: 'Time Zone', key: 'timeZone', type: 'select', options: timezones, showSearch: true, keyAccessor: x => x.zone, valueAccessor: x => x.zone + ' ' + x.gmt, required: true, onChange: v => { setFieldsValue({ timeZone: v }) } },
                { label: 'Currency', key: 'companyCurrency', type: 'select', options: currencies, showSearch: true, required: true, onChange: v => { setFieldsValue({ companyCurrency: v }) } },
                { label: 'Date Format', key: 'dateFormat', type: 'select', options: this.state.dateFormates, required: true, onChange: v => { setFieldsValue({ dateFormat: v }) } },
                { label: 'Director Name', key: 'directorName', required: !isModal },
                {
                    label: 'Director Email', key: 'directorEmail', type: 'email', required: !isModal, onBlur: (e) => {
                        const email = e.target.value;

                        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

                        if (!emailRegex.test(email)) {
                            notification.error({
                                message: 'Please Enter Valid Director Email Address'
                            })
                            // show error (toast / set state / message)
                        } else {
                            // console.log('Valid email');
                        }
                    }
                },
                { label: 'Director Phone Code', key: 'directorCountryCode', type: 'select', options: phoneCodes, showSearch: true, required: !isModal, onChange: v => { setFieldsValue({ directorCountryCode: v }) } },
                {
                    label: 'Director Phone', key: 'directorPhone', required: !isModal, maxLength: 10,
                    onBlur: (e) => {
                        const value = e.target.value;

                        const phoneRegex = /^[0-9]{10}$/;

                        if (!phoneRegex.test(value)) {
                            notification.error({
                                message: 'Invalid phone number (must be 10 digits)'
                            });
                        } else {

                        }
                    }
                },
                {
                    label: 'Countries Recruiting From?',
                    key: 'dealingCountries',
                    type: 'select',
                    options: countries,
                    mode: 'multiple',
                    required: true,
                    onChange: v => {
                        setFieldsValue({ dealingCountries: v })
                    }
                },

                // ✅ RESTORED FIELDS
                { label: 'Website URL', key: 'websiteUrl' },
                { label: 'Facebook URL', key: 'facebookUrl' },
                { label: 'Twitter URL', key: 'twitterUrl' },
                { label: 'Instagram URL', key: 'instagramUrl' },
                { label: 'YouTube URL', key: 'youtubeUrl' },
                { label: 'LinkedIn URL', key: 'linkedinUrl' }
            ]
        };

        return (
            <Card loading={cardLoading}>

                <Form onSubmit={this.handleFormSubmit}>

                    {/* 🔷 LOGO UPLOAD */}
                    <div style={{ marginBottom: 20 }}>
                        <label><b>Business Logo *</b></label>

                        <div style={{ fontSize: 12, color: '#888', marginBottom: 8 }}>
                            Upload square logo (Required size: 130 × 80 px)
                        </div>

                        {getFieldDecorator('companyLogo', {
                            rules: [{ required: false, message: 'Please upload logo' }]
                        })(
                            <Upload
                                listType="picture-card"
                                fileList={files}
                                action={`${LAPI_URL}/filesUploader`}
                                beforeUpload={this.beforeUpload}
                                onPreview={this.handlePreview}
                                onChange={this.handleChange}
                            >
                                {files.length >= 1 ? null : (
                                    <div>
                                        <Icon type="plus" />
                                        <div>Upload</div>
                                    </div>
                                )}
                            </Upload>
                        )}

                        <Modal visible={previewVisible} footer={null} onCancel={this.handleCancel}>
                            <img alt="logo" style={{ width: '100%' }} src={previewImage} />
                        </Modal>
                    </div>

                    <Divider />

                    <GetAllFormFields
                        apiurl={LAPI_URL}
                        inputSchema={inputSchema}
                        getFieldDecorator={getFieldDecorator}
                    />

                    <div style={{ marginTop: 30, textAlign: 'right' }}>
                        {isModal && <Button onClick={this.onPrev} style={{ height: 40, width: 100, marginRight: 10 }}>BACK</Button>}
                        <Button type="primary" htmlType="submit" loading={loading} style={{ height: 40, width: 140 }}>
                            {isModal ? <span> NEXT STEP <Icon type="arrow-right" /></span> : 'SAVE'}
                        </Button>
                    </div>

                </Form>
            </Card>
        )
    }
}

export default BasicCompanyDetails;